import { useEffect } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import Navbar from "./components/Navbar";
import LoginPage from "./components/LoginPage";
import MainPage from "./components/MainPage";
import Dashboard from "./components/admin/Dashboard";
import { useGlobalContext } from "./context";
import ExamsIndexPage from "./components/ExamsIndexPage";
import ExamPage from "./components/ExamPage";
import CertificatesPage from "./components/CertificatesPage";
import TextbooksPage from "./components/TextbooksPage";
import Identification from "./components/Identification";

function App() {
  const { user } = useGlobalContext();
  useEffect(() => {
    const handleContextmenu = (e) => {
      e.preventDefault();
    };
    document.addEventListener("contextmenu", handleContextmenu);
    return function cleanup() {
      document.removeEventListener("contextmenu", handleContextmenu);
    };
  }, []);

  return (
    <Router>
      <div className="vh-100">
        <header>
          <Navbar />
        </header>
        <main>
          <div className="container-lg pt-3 pt-lg-5">
            <Switch>
              <Route exact path="/dashboard">
                {user.id && user.admin ? (
                  <Dashboard />
                ) : (
                  <LoginPage admin={true} />
                )}
              </Route>
              <Route exact path="/login">
                <LoginPage />
              </Route>
              <Route exact path="/certificate">
                {user.id ? <CertificatesPage /> : <LoginPage />}
              </Route>
              <Route exact path="/exam/:id">
                {user.id ? (
                  // <Identification idNumber={user.idNumber}>
                  <ExamPage />
                ) : (
                  // </Identification>
                  <LoginPage />
                )}
              </Route>
              <Route exact path="/textbooks">
                <TextbooksPage />
              </Route>
              <Route path="/">
                {user.id ? (
                  user.admin ? (
                    <Redirect to="/dashboard" />
                  ) : (
                    // <Identification idNumber={user.idNumber}>
                    <ExamsIndexPage />
                    // </Identification>
                  )
                ) : (
                  <LoginPage />
                )}
              </Route>
            </Switch>
          </div>
        </main>
      </div>
    </Router>
  );
}

export default App;
